import { ArrowDown, Star } from "lucide-react";
import { GOOGLE_PROFILE_URL, waLink, WA_MESSAGES } from "@/lib/business";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Hero = () => (
  <section
    id="inicio"
    data-testid="hero-section"
    className="scroll-mt-24 bg-stone-50"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-28">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <p
            data-testid="hero-overline"
            className="hero-in text-xs font-bold uppercase tracking-[0.2em] text-brand"
          >
            Ótica em Mogi Guaçu – SP
          </p>
          <h1
            data-testid="hero-heading"
            className="hero-in mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-stone-900"
            style={{ animationDelay: "100ms" }}
          >
            Qualidade vem antes do{" "}
            <span className="text-brand">preço</span>.
          </h1>
          <p
            data-testid="hero-subheading"
            className="hero-in mt-6 text-base sm:text-lg leading-relaxed text-stone-600 max-w-xl"
            style={{ animationDelay: "200ms" }}
          >
            Na Ótica Danko você encontra armações e lentes de qualidade, com
            atendimento próximo e preço justo. Valorizando e protegendo seus
            olhos, todos os dias.
          </p>
          <a
            href={GOOGLE_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-google-rating"
            className="hero-in mt-7 inline-flex items-center gap-2.5 rounded-full border border-stone-200 bg-white px-5 py-2.5 shadow-sm hover:shadow-md btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            style={{ animationDelay: "300ms" }}
          >
            <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
            <span className="text-sm font-bold text-stone-900">5,0</span>
            <span className="text-sm text-stone-500">
              · 155 avaliações no Google
            </span>
          </a>
          <div
            className="hero-in mt-8 flex flex-col sm:flex-row gap-4"
            style={{ animationDelay: "400ms" }}
          >
            <a
              href={waLink(WA_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-base font-semibold text-white shadow-md hover:bg-brand-dark hover:shadow-lg btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
            >
              <WhatsAppIcon className="w-5 h-5" />
              Conversar pelo WhatsApp
            </a>
            <a
              href="#localizacao"
              data-testid="hero-secondary-button"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-stone-300 bg-white px-7 py-3.5 text-base font-semibold text-stone-700 hover:border-brand hover:text-brand hover:shadow-md btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
            >
              Ver endereço e horário
              <ArrowDown className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div
          className="relative hero-in"
          style={{ animationDelay: "250ms" }}
        >
          <div
            className="absolute -inset-4 rounded-3xl bg-brand-light -z-0"
            aria-hidden="true"
          />
          <img
            src="/assets/fachada.png"
            alt="Fachada da Ótica Danko em Mogi Guaçu, com letreiro verde e a frase: Na Ótica Danko, qualidade vem antes do preço!"
            data-testid="hero-image"
            className="relative z-10 w-full rounded-2xl shadow-lg object-cover"
            loading="eager"
          />
        </div>
      </div>
    </div>
  </section>
);
